<ng-container *ngIf="value !== null">{{ value | priceWithTax : symbol : position }}</ng-container>
